import { Component, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ndms-textarea',
  templateUrl: './ndms-textarea.component.html',
  styleUrls: ['./ndms-textarea.component.scss']
})
export class NdmsTextareaComponent extends NdmsFormControlComponent implements OnInit {
  
    constructor(viewContainerRef: ViewContainerRef) {
      super(viewContainerRef);
     }
  
    ngOnInit() {
    }
  
    canAddArrayItem(currentIndex: number) {
      return true;
    }
    getText() {
        if(!this.value)
        {
            return 'N/A';
        }
        return this.value;
    }
}
